"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionsTabs = exports.BuiltInResponseOptionsTab = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_1 = require("react");
var ResponseOptionsContainer_1 = require("./ResponseOptionsContainer");
var constants_1 = __importDefault(require("../../constants"));
var common_1 = require("../common");
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var RogTab = styled_components_1.default.span.attrs({
    className: 'tws-rog-tab',
    'data-testid': 'tws-rog-tab',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tborder-bottom: 1px solid #2a9fd8;\n\tpadding: 10px 40px;\n\n\t&.active {\n\t\tborder-bottom: 3px solid #2a9fd8;\n\t\tpadding: 10px 40px 8px 40px;\n\t}\n"], ["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tborder-bottom: 1px solid #2a9fd8;\n\tpadding: 10px 40px;\n\n\t&.active {\n\t\tborder-bottom: 3px solid #2a9fd8;\n\t\tpadding: 10px 40px 8px 40px;\n\t}\n"])));
var WarningModelContentContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\ttext-align: center;\n"], ["\n\ttext-align: center;\n"])));
var BuiltInResponseOptionsTab;
(function (BuiltInResponseOptionsTab) {
    BuiltInResponseOptionsTab[BuiltInResponseOptionsTab["Standard"] = 0] = "Standard";
    BuiltInResponseOptionsTab[BuiltInResponseOptionsTab["Custom"] = 1] = "Custom";
})(BuiltInResponseOptionsTab = exports.BuiltInResponseOptionsTab || (exports.BuiltInResponseOptionsTab = {}));
function ResponseOptionsTabs(props) {
    var _a, _b;
    var responseOptionsTabItems = props.responseOptionsTabItems, tabChange = props.tabChange;
    var _c = (0, react_1.useState)(props.activeKey), activeKey = _c[0], SetActiveKey = _c[1];
    var _d = (0, react_1.useState)(''), switchToTabKey = _d[0], SetSwitchToTabKey = _d[1];
    var _e = (0, react_1.useState)(false), warningModalOpen = _e[0], SetWarningModalOpen = _e[1];
    responseOptionsTabItems.forEach(function (tabItem) { return (tabItem.tabKey = getTabKey(tabItem)); });
    var activeTabItem = responseOptionsTabItems.find(function (_) { return _.tabKey == activeKey; });
    function onTabClick(tabKey) {
        // No need to handle anything if clicking the current tab
        if (activeKey == tabKey)
            return;
        // Switch tab directly if current tab is Standard
        // Otherwise, show warning modal dialog
        if (activeKey != constants_1.default.RESPONSE_OPTION_GROUP_TAB_STANDARD) {
            SetSwitchToTabKey(tabKey);
            SetWarningModalOpen(!warningModalOpen);
        }
        else {
            SetActiveKey(tabKey);
            if (tabChange) {
                tabChange(tabKey);
            }
        }
    }
    function closeWarning() {
        SetWarningModalOpen(!warningModalOpen);
    }
    function confirmWarning() {
        if (switchToTabKey) {
            SetActiveKey(switchToTabKey);
            if (tabChange) {
                tabChange(switchToTabKey);
            }
            SetWarningModalOpen(!warningModalOpen);
        }
    }
    function getTabKey(tabItem) {
        var _a;
        if (tabItem.type === BuiltInResponseOptionsTab.Standard)
            return constants_1.default.RESPONSE_OPTION_GROUP_TAB_STANDARD;
        if (tabItem.type === BuiltInResponseOptionsTab.Custom)
            return constants_1.default.RESPONSE_OPTION_GROUP_TAB_CUSTOM;
        return (_a = tabItem.tabKey) !== null && _a !== void 0 ? _a : '';
    }
    function getTabDescription(tabItem) {
        var _a;
        if ((tabItem === null || tabItem === void 0 ? void 0 : tabItem.type) === BuiltInResponseOptionsTab.Standard)
            return contentConstants_1.default.RESPONSE_OPTION_GROUP_TAB_SINGLE_RESPONSE;
        if ((tabItem === null || tabItem === void 0 ? void 0 : tabItem.type) === BuiltInResponseOptionsTab.Custom)
            return contentConstants_1.default.RESPONSE_OPTION_GROUP_TAB_MULTIPLE_RESPONSE;
        return (_a = tabItem === null || tabItem === void 0 ? void 0 : tabItem.description) !== null && _a !== void 0 ? _a : '';
    }
    return (React.createElement(common_1.Section, { id: 'response-options-tabs', sectionHeader: contentConstants_1.default.SECTIONHEADERS_CUSTOM_QUESTION_CHOOSE_RESPONSEOPTION },
        React.createElement(aon_tws_common_ui_1.ClearDiv, null, responseOptionsTabItems.map(function (tabItem, i) {
            return (React.createElement(RogTab, { key: i, className: activeKey === tabItem.tabKey ? 'active' : '', onClick: function () { var _a; return onTabClick((_a = tabItem.tabKey) !== null && _a !== void 0 ? _a : ''); } }, tabItem.tabKey));
        })),
        React.createElement("div", null,
            React.createElement(ResponseOptionsContainer_1.ResponseOptionsContainer, { description: getTabDescription(activeTabItem) },
                React.createElement(React.Fragment, null, activeTabItem === null || activeTabItem === void 0 ? void 0 : activeTabItem.component))),
        warningModalOpen && (React.createElement(aon_tws_common_ui_1.ModalPopup, { isOpen: warningModalOpen, title: 'Warning', primaryButtonText: 'Continue', secondaryButtonText: 'Cancel', onClosed: closeWarning, onSubmit: confirmWarning, contenthcentered: true, contentvcentered: true, contentfullwidth: false, type: 'lightbox', headericon: 'warning', headericoncolor: '#ff0000' },
            React.createElement(WarningModelContentContainer, null,
                React.createElement("b", null, (_a = activeTabItem === null || activeTabItem === void 0 ? void 0 : activeTabItem.warningHeadline) !== null && _a !== void 0 ? _a : contentConstants_1.default.RESPONSE_OPTION_GROUP_TAB_WARNING_HEADLINE),
                React.createElement("br", null),
                React.createElement("br", null), (_b = activeTabItem === null || activeTabItem === void 0 ? void 0 : activeTabItem.warningMessage) !== null && _b !== void 0 ? _b : contentConstants_1.default.RESPONSE_OPTION_GROUP_TAB_WARNING_BODY,
                React.createElement("br", null))))));
}
exports.ResponseOptionsTabs = ResponseOptionsTabs;
var templateObject_1, templateObject_2;
